import { aboutPage } from 'utils/pageTemplates/aboutPage';

const { getStaticProps, AboutPageComponent } = aboutPage();

export { getStaticProps };
export default AboutPageComponent;
